/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { ReactComponent as UKFlag } from "components/widgets/language/flag-united-kingdom.svg";
import { ReactComponent as UAEFlag } from "components/widgets/language/flag-united-arab-emirates.svg";
import { ReactComponent as FRFlag } from "components/widgets/language/flag-france.svg";
import { ReactComponent as DEFlag } from "components/widgets/language/flag-germany.svg";
import { ReactComponent as RUFlag } from "components/widgets/language/flag-russia.svg";
import { ReactComponent as ESFlag } from "components/widgets/language/flag-spain.svg";
import { ReactComponent as TRFlag } from "components/widgets/language/flag-turkey.svg";

const ActiveLanguage = () => {
  const getLanguage = () => {
    switch (localStorage.getItem("i18nextLng")) {
      case "en-US":
        return ["English", <UKFlag className="img-fluid flag" />];
      case "ar-AE":
        return ["Arabic", <UAEFlag className="img-fluid flag" />];
      case "fr-FR":
        return ["French", <FRFlag className="img-fluid flag" />];
      case "de-DE":
        return ["German", <DEFlag className="img-fluid flag" />];
      case "ru-RU":
        return ["Russian", <RUFlag className="img-fluid flag" />];
      case "es-ES":
        return ["Spanish", <ESFlag className="img-fluid flag" />];
      case "tr-TR":
        return ["Turkish", <TRFlag className="img-fluid flag" />];

      default:
        return ["English", <UKFlag className="img-fluid flag" />];
    }
  };

  return (
    <div className="activeLang">
      {getLanguage()[0]}
      {getLanguage()[1]}
      {getLanguage()[2]}
      {getLanguage()[3]}
      {getLanguage()[4]}
      {getLanguage()[5]}
      {getLanguage()[6]}
    </div>
  );
};

export default ActiveLanguage;
